export const isValidEmail = (email: string): boolean => {
  const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
  return regex.test(email)
}

export const isDuplicateEmail = (email: string, existingEmails: string[]): boolean => {
  return existingEmails.map((e) => e.toLowerCase()).includes(email.toLowerCase())
}


